import { render, staticRenderFns } from "./CountedServiceTypeAdd.vue?vue&type=template&id=01594c5f&"
import script from "./CountedServiceTypeAdd.vue?vue&type=script&lang=js&"
export * from "./CountedServiceTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports